import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "@/components/about/AboutPage";
import { aboutSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/about")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => aboutSeo(loaderData?.href ?? "/about"),
  component: AboutPage,
});
